// @flow

import * as React from 'react';

import { useField } from 'react-final-form';

import { certificates } from '@gandi/redux-resource-price';
import { useTranslator } from '@gandi/translate';
import { Base, Block, BlockContent, BlockHeading, Svg } from '@gandi/ui';

import {
  CERT_PROVIDER_INPUT_NAME,
  CERT_TYPE_INPUT_NAME,
  CERT_TYPE_PROTECT_INPUT_NAME,
  CERT_WARRANTY_INPUT_NAME,
} from '../../consts';

// force no digits & USD to display warranty amount
const options = {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
};

export function WarrantyInfo(): React.MixedElement {
  const { __, formatNumber } = useTranslator();

  const {
    input: { value: provider },
    // $FlowFixMe[prop-missing]
  } = useField(CERT_PROVIDER_INPUT_NAME, { subscription: { value: true } });
  const {
    input: { value: type },
    // $FlowFixMe[prop-missing]
  } = useField(CERT_TYPE_INPUT_NAME, { subscription: { value: true } });
  const {
    input: { value: protect },
    // $FlowFixMe[prop-missing]
  } = useField(CERT_TYPE_PROTECT_INPUT_NAME, { subscription: { value: true } });
  const {
    input: { value: warranty },
    // $FlowFixMe[prop-missing]
  } = useField(CERT_WARRANTY_INPUT_NAME, { subscription: { value: true } });

  const warrantyOption = certificates.getWarrantyOption({
    provider,
    type,
    protect,
    warranty,
  });

  return (
    <Block>
      <BlockHeading>{__('Warranty')}</BlockHeading>
      <BlockContent>
        <Base flex gap="xsmall">
          <Base
            flex
            flexAlignItemsCenter
            flexAlignSelfStart
            style={{ height: '1lh' }}
          >
            <Svg name="successWire" size="4x" theme="success" />
          </Base>
          <Base tagName="p" margin="none">
            {__('Up to %(price)s.', {
              price: formatNumber(parseInt(warrantyOption, 10), options),
            })}
          </Base>
        </Base>
      </BlockContent>
    </Block>
  );
}
